
import { useNavigate } from "react-router-dom";
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { envVariables } from "../../../../helpers";
import { useGranjassStore } from "../../../../store";
import { AlertScreen } from "../../components/AlertScreen";

const paginado = Number( envVariables.REACT_APP_PAGINADO);




export const TablaListGranja = ({ data, chagePage, page }) => {


    const navigate = useNavigate();
    const { totalGranjas } = useGranjassStore();


    const handleOpcionesGranja = (id) => {
        navigate(`/admin/opcion/${id}/granja`)
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'30%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'15%'}}>MTS2</TableCell>
                                <TableCell sx={{width:'20%'}}>CIUDAD</TableCell>
                                <TableCell sx={{width:'15%'}}>#GALPONES</TableCell>
                                <TableCell sx={{width:'15%'}}>#BODEGAS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (granja) => (
                            <TableRow key={ granja.id } onClick={ () => handleOpcionesGranja(granja.id) }  sx={{cursor:'pointer'}}>
                                <TableCell>{ granja.nombre }</TableCell>   
                                <TableCell>{ granja.metros }</TableCell>
                                <TableCell>{ granja?.ciudad?.name }</TableCell>
                                <TableCell>{ granja.canGalpones }</TableCell>
                                <TableCell>{ granja.canBodegas }</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalGranjas / paginado)} disabled={Math.ceil(totalGranjas / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay granjas creadas por el momento..."/>
        }
        </>
    )
}
